export default __webpack_public_path__ + "static/media/loading@3x.cc229b34.png";